module.exports = __webpack_public_path__ + "static/img/JOE-PIKE.a013b6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOE-PIKE.jpg
// module id = rPiv
// module chunks = 0